import styled from "styled-components";

const VisionCard = ({ title, description, Icon, BgIcon }) => {
  return (
    <CardWrapper>
      <BackgroundIcon>{BgIcon && <BgIcon size={120} />}</BackgroundIcon>

      <Content>
        <Header>
          {Icon && <MainIcon>{<Icon size={24} />}</MainIcon>}
          <Title>{title}</Title>
        </Header>

        <Description>{description}</Description>
      </Content>
    </CardWrapper>
  );
};

export default VisionCard;

const CardWrapper = styled.div`
  position: relative;
  overflow: hidden;
  z-index: 1;
`;

const BackgroundIcon = styled.div`
  position: absolute;
  top: -10px;
  right: -10px;
  opacity: 0.06;
  z-index: 0;

  svg {
    width: 140px;
    height: 140px;

    @media (max-width: 768px) {
      width: 100px;
      height: 100px;
    }
  }
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

const MainIcon = styled.div`
  color: #0d6efd; // primary
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 48px;
    height: 48px;

    @media (max-width: 768px) {
      width: 25px;
      height: auto;
    }
  }
`;

const Title = styled.h3`
  font-size: 30;
  font-weight: 700;
  color: #222;

  @media (max-width: 768px) {
    font-size: 1.125rem;
  }
`;

const Description = styled.p`
  color: #0d0a19;
  line-height: 1.6;
  font-size: 0.95rem;

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`;
